import { ActionType } from './actions';
import { Dispatch, useContext } from 'react';
import { EngagementMode, SharedScreenState } from '@/types/screen';
import { createContext } from 'react';

export const defaultInitialState: SharedScreenState = {
  eventId: '',
  savedTheme: {
    stageElements: {},
    fanElements: {},
  },
  draftTheme: {},
  selectedElementId: null,
  activeEngagement: null,
  engagementMode: EngagementMode.Actual,
};

export interface ScreenThemeStateContextType {
  dispatch: Dispatch<ActionType>;
  state: SharedScreenState;
}

export const screenThemeStateContext =
  createContext<ScreenThemeStateContextType>({
    dispatch: () => {},
    state: defaultInitialState,
  });

export function useScreenThemeState() {
  return useContext(screenThemeStateContext);
}
